import { DirectionForward } from '@clearkit/icons';
import classNames from 'classnames';
import { CKCheckboxNext } from 'clearkit';

import { routes } from '~/components/app/appMainRoutes';
import CompanyNameAndSocialIconsCell from '~/components/tools/CompanyNameAndSocialIconsCell';
import ProspectorButton from '~/components/tools/ProspectorButton';
import history from '~/lib/history';

import { TargetMarketsCompany } from '../types';

const CompanyRow = ({
  data,
  loading,
  isSelected,
  handleSelect,
  number,
}: {
  data: TargetMarketsCompany;
  loading: boolean;
  isSelected: boolean;
  handleSelect: (domain: string, isChecked: boolean) => void;
  number: number;
}) => {
  const {
    name,
    domain,
    industry,
    employees_range,
    country,
    crunchbase,
    linkedin,
    twitter,
  } = data;

  return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    <div
      className="flex flex-col items-center justify-center w-full px-6 py-2 text-sm text-gray-600 bg-white border-b rounded-sm xl:px-10 lg:grid gap-2 transition-all duration-200 group hover:bg-gray-50 grid-cols-[repeat(17,_minmax(0,_1fr))]"
      onClick={() =>
        loading ? {} : history.push(`${routes.targetMarkets}/${domain}`)
      }
      role="button"
    >
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className="text-gray-500 col-span-1"
        onClick={(e) => e.stopPropagation()}
      >
        <CKCheckboxNext
          checked={isSelected}
          className={classNames('text-sm text-gray-600 z-20 relative', {
            'ck-skeleton': loading,
          })}
          isDisabled={loading}
          key={domain + isSelected ? 'selected' : 'not-selected'}
          onChange={(checked) => handleSelect(domain, checked)}
        >
          <span
            className={classNames('text-gray-500 col-span-1 text-xs', {
              'ck-skeleton': loading,
            })}
          >
            {number}
          </span>
        </CKCheckboxNext>
      </div>

      <CompanyNameAndSocialIconsCell
        crunchbase={crunchbase}
        domain={domain}
        linkedin={linkedin}
        loading={loading}
        loadingEnrichment={loading}
        name={name}
        twitter={twitter}
      />

      <p className={classNames('col-span-3', { 'ck-skeleton': loading })}>
        {country || '-'}
      </p>

      <p className={classNames('col-span-3', { 'ck-skeleton': loading })}>
        {industry || '-'}
      </p>

      <p className={classNames('col-span-3', { 'ck-skeleton': loading })}>
        {employees_range || '-'}
      </p>

      <div className="items-center justify-end hidden lg:flex col-span-2 gap-2 2xl:gap-3">
        <ProspectorButton domain={domain} loading={loading} name={name} />

        <DirectionForward
          className={classNames('flex-shrink-0 group-hover:text-blue-500', {
            'ck-skeleton': loading,
          })}
        />
      </div>
    </div>
  );
};

export default CompanyRow;
